// Configuración de HTTP con Axios
// Migrado desde http-common.js

import type { AxiosInstance, AxiosResponse } from "axios";
import { httpClient } from "@wkt/lib/httpClient";

/**
 * Instancia de Axios configurada para la aplicación
 */
export const HTTP: AxiosInstance = httpClient;

/**
 * Utilidades para manejo de HTTP
 */
export const UTILS = {
  /**
   * Descarga un documento desde una respuesta HTTP
   */
  downloadDocument(response: AxiosResponse): void {
    const link = document.createElement("a");

    // Obtener nombre del archivo
    let fileName = response.headers["x-file-name"];
    if (!fileName) {
      const regExpFilename = /filename="(.*)"/;
      const cdheader = response.headers["content-disposition"];
      if (cdheader) {
        const res = regExpFilename.exec(cdheader);
        if (res && res.length > 0) {
          fileName = res[1];
        }
      }
    }

    // Crear blob
    const contentType = response.headers["content-type"];
    const blob = new Blob([response.data], { type: contentType });

    // Soporte IE (legacy)
    const nav = window.navigator as any;
    if (nav && nav.msSaveOrOpenBlob) {
      nav.msSaveOrOpenBlob(blob, fileName);
      return;
    }

    // Descarga estándar
    const url = window.URL.createObjectURL(blob);
    link.href = url;
    link.download = fileName || "download";
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 1000);
  },
};
